/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Repeat_WordsInputs */



/**
* | output |
* | --- |
* | "Remove Repeat Words" |
*
* @param {Remove_Repeat_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_repeat_words = /** @type {((inputs?: Remove_Repeat_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Repeat_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les mots répétés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entferne doppelte Wörter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi le parole ripetute")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить повторяющиеся слова")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar palabras repetidas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除重复词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複した単語を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोहराए गए शब्दों को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover palavras repetidas")
	return /** @type {LocalizedString} */ ("Remove Repeat Words")
});